'use strict';

const { h } = require('phy');

const MerchantLogoImage = require('../../shared/views/merchants/merchant-logo-image');
const OfferCalloutImage = require('../../shared/views/offer/offer-callout-image');
const OfferTypeLabel = require('../../shared/views/offer/offer-type-label');
const CouponButton = require('./coupon-button');
const OfferRedemptionCount = require('../../shared/views/offer/offer-redemption-count');
const OfferExpiry = require('../../shared/views/offer/offer-expiry');
const OfferViewTerms = require('../../shared/views/offer/offer-view-terms');
const OfferFinancialTerms = require('../../shared/views/offer/offer-financial-terms');
const OfferExclusive = require('../../shared/views/offer/offer-exclusive');
const OfferRedemptionText = require('../../shared/views/offer/offer-redemption-text');

function getTileImage({ coupon, media, routes, lazy }) {
  if (media === 'callout') {
    return h('.coupon-tile-callout', [
      OfferCalloutImage({
        className: 'coupon-tile-callout-image',
        data: coupon && coupon.offerMedia,
        alt: coupon.calloutValue,
        size: {
          width: 160,
          height: 80,
        },
        lazy,
      }),
    ]);
  }

  return h(
    'a.coupon-tile-logo',
    {
      href: routes.merchant.show.replace(
        '{merchantSlug}',
        coupon.merchant.merchantSlug
      ),
    },
    [
      MerchantLogoImage({
        data: coupon && coupon.merchant && coupon.merchant.merchantMedia,
        alt: `${coupon.merchant.merchantName} - ${coupon.calloutValue}`,
        size: { width: 78, height: 78 },
      }),
    ]
  );
}

function CouponTile({
  coupon,
  media,
  routes,
  lazy = true,
  showCallouts = true,
}) {
  const ExpiryElement = OfferExpiry({
    className: 'coupon-tile-expiry',
    expires: coupon.expiryDateTime,
  });

  const ExclusiveElement =
    coupon.isExclusive &&
    OfferExclusive({ className: 'coupon-tile-exclusive' });

  return h(`.coupon-tile${showCallouts ? '' : '.no-callout'}`, [
    showCallouts && getTileImage({ coupon, media, routes, lazy }),
    h('.coupon-tile-inner', [
      h('.coupon-tile-content', [
        OfferTypeLabel({ coupon, className: 'coupon-tile-type' }),
        ExclusiveElement,
        h('h3.coupon-tile-title', coupon.offerTitle),
        coupon.offerDescription &&
          h('p.coupon-tile-description', coupon.offerDescription),
      ]),
      OfferFinancialTerms({
        terms: coupon.financialTerms,
        className: 'coupon-tile-financial',
      }),
      h('.coupon-tile-action', [
        h(
          '.coupon-tile-button',
          OfferRedemptionText({
            type: coupon.offerType,
          })
        ),
      ]),
    ]),
    h('.coupon-tile-info', [
      OfferRedemptionCount({
        className: 'coupon-tile-used',
        stats: coupon.offerStatistics,
      }),
      ExpiryElement,
      OfferViewTerms({
        offerId: coupon.offerId,
        className: 'coupon-tile-terms',
      }),
    ]),
    h(CouponButton, {
      coupon,
      className: 'coupon-background',
    }),
  ]);
}

module.exports = CouponTile;
